import Pristine from '@/utility/pristine';

export function isDescendant(parent, child) {
  var node = child.parentNode;

  while (node != null) {
    if (node == parent) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}

export function serialize(form) {
  var serialized = [];

  for (var i = 0; i < form.elements.length; i++) {
    var field = form.elements[i];

    // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
    if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

    // If a multi-select, get all selections
    if (field.type === 'select-multiple') {
      for (var n = 0; n < field.options.length; n++) {
        if (!field.options[n].selected) continue;
        serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
      }
    } else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
      serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
    }
  }

  return serialized.join('&').replace(/%20/g, '+');
}

export function debounce(callback, interval) {
  let debounceTimeout;

  return function(...args) {
    clearTimeout(debounceTimeout);

    debounceTimeout = setTimeout(() => {
      callback.apply(this, args)
    }, interval);
  };
}

export function throttle(callback, interval) {
  let throttleTimeout;
  let enableRun = true;

  return function(...args) {
    if(enableRun) {
      callback.apply(this, args);

      enableRun = false;

      throttleTimeout = setTimeout(() => enableRun = true, interval);
    } else {
      clearTimeout(throttleTimeout);

      throttleTimeout = setTimeout(function() {
        callback.apply(this, args);

        enableRun = true;
      }, interval);
    }
  }
}

export function loadScript(url, callback) {
  let script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = url;

  script.onreadystatechange = callback;
  script.onload = callback;

  document.head.appendChild(script);
}

export function moneyFormat(value) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return formatter.format(value);
}

export function scrollToDanger(classTarget) {
  classTarget = classTarget || '.has-danger';
  let $el = document.querySelector(classTarget);

  if($el.firstChild && $el.firstChild.nodeName !== '#text') {
    $el = $target.firstChild;
  }

  if(window.scroll) {
    window.scroll({
      top: $el.getBoundingClientRect().y - 25 - document.body.getBoundingClientRect().top - document.getElementById('sticky-header').clientHeight,
      behavior: 'smooth',
    });

    return;
  }

  $el.scrollIntoView(true);
}

export function nodeFromHtml(htmlString) {
  let div = document.createElement('div');
  div.innerHTML = htmlString.trim();

  return div.firstChild;
}

export function isObject(obj) {
  return typeof obj === 'object' && !!obj;
}

export function getQueryString(url) {
  let parser = document.createElement('a');
      parser.href = url;

  return parser.search.substring(1);
}

export function addEvent(target, type, callback) {
  target.addEventListener(type, callback, !1);
}

export function triggerEvent(target, type) {
  let event = null;

  try {
    event = new Event(type);
  } catch(error) {
    event = document.createEvent('Event');
    event.initEvent(type, false, false);
  }

  target.dispatchEvent(event);
}

export function oneTimeEvent(target, type, callback) {
  const _callback = (e) => {
    e.target.removeEventListener(e.type, _callback);

    return callback(e);
  };

  addEvent(target, type, _callback);
}

export function downloadFile(data, filename, mime, bom) {
  var blobData = (typeof bom !== 'undefined') ? [bom, data] : [data]
  var blob = new Blob(blobData, {type: mime || 'application/octet-stream'});
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    // IE workaround for "HTML7007: One or more blob URLs were
    // revoked by closing the blob for which they were created.
    // These URLs will no longer resolve as the data backing
    // the URL has been freed."
    window.navigator.msSaveBlob(blob, filename);
  } else {
    var blobURL = (window.URL && window.URL.createObjectURL)
      ? window.URL.createObjectURL(blob)
      : window.webkitURL.createObjectURL(blob);
    var tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = blobURL;
    tempLink.setAttribute('download', filename);

    // Safari thinks _blank anchor are pop ups. We only want to set _blank
    // target if the browser does not support the HTML5 download attribute.
    // This allows you to download files in desktop safari if pop up blocking
    // is enabled.
    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank');
    }

    document.body.appendChild(tempLink);
    tempLink.click();

    // Fixes "webkit blob resource error 1"
    setTimeout(function() {
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
    }, 200);
  }
}

export function revalidateRelatedInputs(nodes) {
  let $inputs, $target;

  for(var n = 0; n < nodes.length; n++) {
    if(nodes[n].checked === false) {
      $target = document.querySelector(nodes[n].dataset.showTarget);

      if(!$target) {
        continue;
      }

      $inputs = $target.querySelectorAll('input, textarea, select');

      if($inputs.length > 0) {
        window.validator.validate($inputs, true);
      }
    }
  }
}

export function setupFormValidation(form, callback) {
  window.validator = new Pristine(form, {
    classTo: 'input-wrap',
    errorClass: 'has-danger',
    errorTextClass: 'text-help',
    errorTextParent: 'input-wrap',
    errorTextTag: 'div',
    successClass: 'has-success',
  });

  // submit handler
  form.addEventListener('submit', e => {
    if(callback) {
      return callback(e);
    }

    const $submit = form.querySelector('[type="submit"]');

    $submit.setAttribute('disabled', true);

    if(!window.validator.validate()) {
      e.preventDefault();

      scrollToDanger();

      $submit.removeAttribute('disabled');

      return false;
    }

    $submit.setAttribute('disabled', true);
  });
}

export function selectorSupported(selector) {
  var support,
    link,
    sheet,
    doc = document,
    root = doc.documentElement,
    head = root.getElementsByTagName('head')[0],
    impl = doc.implementation || {
        hasFeature: function() {
            return false;
        }
    },
    link = doc.createElement("style");

  link.type = 'text/css';

  (head || root).insertBefore(link, (head || root).firstChild);

  sheet = link.sheet || link.styleSheet;

  if (!(sheet && selector)) return false;

  support = impl.hasFeature('CSS2', '') ?

    function(selector) {
        try {
            sheet.insertRule(selector + '{ }', 0);
            sheet.deleteRule(sheet.cssRules.length - 1);
        } catch (e) {
            return false;
        }

        return true;
    } : function(selector) {
        sheet.cssText = selector + ' { }';

        return sheet.cssText.length !== 0 && !(/unknown/i).test(sheet.cssText) && sheet.cssText.indexOf(selector) === 0;
    };

  return support(selector);
};

export function requireAll(r) {
  return r.keys().forEach(r);
};

export function plural(value, word, suffix = 's') {
  if(value == 1) {
    return value + ' ' + word;
  }

  return value + ' ' + word + suffix;
};

export function getSiblings(el) {
  // for collecting siblings
  let siblings = [];
  // if no parent, return no sibling
  if(!el.parentNode) {
      return siblings;
  }
  // first child of the parent node
  let sibling  = el.parentNode.firstChild;

  // collecting siblings
  while (sibling) {
      if (sibling.nodeType === 1 && sibling !== el) {
          siblings.push(sibling);
      }
      sibling = sibling.nextSibling;
  }

  return siblings;
};
